import _ from 'lodash';
import { transparentize } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';

import { IconStar } from '../../easyclaim.app.assets/index';
import { FadeIn } from '../animations/FadeIn';

interface StarRatingProps {
	rating?: number;
	range: number;
	onChange: (rating: number) => void;
	className?: string;
}

interface StarRatingState {
	mouseOver?: number;
}

export class StarRating extends React.Component<StarRatingProps, StarRatingState> {
	constructor(props: StarRatingProps) {
		super(props);

		this.state = {};
	}
	render() {
		return (
			<Container className={`star-rating ${this.props.className}`}>
				{_.range(0, this.props.range).map((i) => (
					<StyledStarIcon
						key={i}
						selected={
							this.state.mouseOver
								? this.state.mouseOver > i
								: this.props.rating
									? this.props.rating > i
									: false
						}
						//if selected is true then className is "star-filled" else "star-empty"
						className={
							this.state.mouseOver
								? this.state.mouseOver > i
									? 'star-filled'
									: 'star-empty'
								: this.props.rating
									? this.props.rating > i
										? 'star-filled'
										: 'star-empty'
									: 'star-empty'
						}
						onClick={() => this.props.onChange(i + 1)}
						onMouseEnter={() => this.setState({ mouseOver: i + 1 })}
						onMouseLeave={() => this.setState({ mouseOver: undefined })}
					/>
				))}
			</Container>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	animation: ${css`
			${FadeIn}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;

interface StyledStarIconProps {
	selected: boolean;
}

const StyledStarIcon = styled(IconStar)<StyledStarIconProps>`
	height: 2rem;
	margin: 0.5rem auto 2rem auto;
	color: ${(p) =>
		p.selected ? 'rgb(254, 192, 88)' : transparentize(0.8, p.theme.colors.secondary)};
	animation: ${css`
			${FadeIn}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
	cursor: pointer;
	transition: color 0.5s ease-in-out;
	flex-grow: 1;
	flex-shrink: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;
